<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th class="text-right">Total de operações</th>
        <th class="text-right">Quantidade total</th>
      </tr>
    </thead>

    <tbody class="grey lighten-2 font-weight-medium">
      <tr>
        <td class="text-right">
          {{ totalCountString }}
        </td>

        <td :class="['text-right', { 'error--text': overview.totalQuantity < 0 }]">
          {{ totalQuantityString }}
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import { formatNumber } from '@/utils/format-utils';

export default {
  name: 'LoanOperationsOverview',

  props: {
    overview: {
      type: Object,
      required: true,
    },
  },

  computed: {
    totalCountString: (vm) => formatNumber(vm.overview.totalCount ?? 0),
    totalQuantityString: (vm) => formatNumber(vm.overview.totalQuantity ?? 0),
  },
};
</script>
